import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
export const useIntegrations = (param)=>{
    let { enabled, refreshOnHookMount = false, withLoader = false } = param;
    var _useStore;
    const { api } = useStoreActions();
    const businessId = (_useStore = useStore(selectors.user.business)) === null || _useStore === void 0 ? void 0 : _useStore.id;
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.Integrations,
            businessId
        ],
        queryFn: ()=>api.integration.getAll(),
        enabled,
        staleTime: 2000,
        refreshOnHookMount,
        withLoader
    });
    return {
        integrations: data,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
